'use client'
import Image from 'next/image'
import { useState } from 'react'
import { Swiper as SwiperObject } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import '../../../styles/productSlideshow.css'

interface Props {
  images: any[]
  title: string
  className?: string
}

export const ProductSlideshow = ({ images, title, className }: Props) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperObject>()

  let localSrc: string = ''
  if (!images.length) {
    localSrc = `/imgs/placeholder.webp`
    images.push({ url: localSrc })
  }

  return (
    <div>
      <div className="flex felx-row">
        {/* Para los thumbs */}
        {images.length ? (
          <Swiper
            onSwiper={setThumbsSwiper}
            watchSlidesProgress={true}
            modules={[Navigation, Thumbs]}
            className="thumbsSwiper"
          >
            {images.map((image, index) => (
              <SwiperSlide key={`${image?.url}-${index}`}>
                <Image
                  width={200}
                  height={200}
                  src={`${image.url}`}
                  alt={title}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <></>
        )}
        <Swiper
          navigation={true}
          slidesPerView={1}
          centeredSlides={true}
          thumbs={{
            swiper:
              thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
          }}
          modules={[Navigation, Thumbs]}
          className="mainSwiper"
        >
          {images.length &&
            images.map((image, index) => (
              <SwiperSlide key={`${image.url}-${index}`}>
                <Image
                  width={500}
                  height={500}
                  src={`${image.url}`}
                  alt={title}
                />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </div>
  )
}
